import { authHeader, handleResponse } from '../helpers';
export const userService = {
    createUser,
    updateUser,
    fetchUserData,
    fetchUserDataAgent,
    inActiveRow,
    inActiveRowDealer,
    createUserDealer,
    updateUserDealer,deleteUserDealer
};

function createUser(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/CreateUser`, requestOptions)
        .then(handleResponse);
}

function updateUser(data) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/UpdateUser`, requestOptions)
        .then(handleResponse);
}


function fetchUserData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetUsers`, requestOptions)
        .then(handleResponse);
}


function inActiveRow(userId, isActive) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/InActiveRow/${userId}/${isActive}`, requestOptions)
        .then(handleResponse);
}




function inActiveRowDealer(Id, isActive) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}ServiceAgent/InActiveRow/${Id}/${isActive}`, requestOptions)
        .then(handleResponse);
}

function createUserDealer(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ServiceAgent/AddAgent`, requestOptions)
        .then(handleResponse);
}

function updateUserDealer(data) {
console.log("data in service", data)
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ServiceAgent/UpdateServiceAgent`, requestOptions)
        .then(handleResponse);
}


function fetchUserDataAgent(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}ServiceAgent/GetAgentList`, requestOptions)
        .then(handleResponse);
}


function deleteUserDealer(id) {
    console.log("id in service", id)
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(
        `${process.env.REACT_APP_API_URL}ServiceAgent/DeleteAgent/${id}`,
        requestOptions
    ).then(handleResponse);
}